// src/App.js - FINALE, VOLLSTÄNDIGE VERSION MIT ALLEN ANSICHTEN UND KORREKTER DATENSPEICHERUNG

import React, { useState, useEffect, useMemo } from 'react';
// 1. Firebase Kern-Module (NUR EINMAL IMPORTIEREN)
import { db, auth, storage } from './firebase';

// 2. Firestore Funktionen
import {
  collection, onSnapshot, query, orderBy, addDoc,
  serverTimestamp, where, doc, deleteDoc, updateDoc
} from 'firebase/firestore';

// 3. Auth Funktionen
import {
  GoogleAuthProvider, signInWithPopup, onAuthStateChanged, signOut,
  createUserWithEmailAndPassword, signInWithEmailAndPassword
} from "firebase/auth";

// 4. Storage Funktionen (für den Bild-Upload)
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

import './App.css';


// Das "Nachschlagewerk" für den zOrder
const zOrderMap = {
  "BUN_BOTTOM": 1,
  "BUN": 1,
  "MEAT": 2,
  "CHEESE": 3,
  "VEGETABLE": 4,
  "SAUCE": 5,
  "SECRET": 6,
  "FISH": 7,
  "BUN_TOP": 20,
  "BEILAGE": 30,
  "B_SAUCE": 31,
  "B_SAUCE_2": 31.5,
  "B_SALAT": 32
};
const ADMIN_EMAIL = "marcmey007@gmail.com";
function App() {
  // === STATES FÜR DIE GESAMTE APP ===
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [ingredients, setIngredients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentBurger, setCurrentBurger] = useState([]);
  const [activeView, setActiveView] = useState('creator'); // 'creator' oder 'saved'
  const [savedBurgers, setSavedBurgers] = useState([]);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isRegistering, setIsRegistering] = useState(false); // Wechselt zwischen Login und Reg.
  const [newIngName, setNewIngName] = useState("");
  const [newIngCategory, setNewIngCategory] = useState("MEAT");
  const [newIngPrice, setNewIngPrice] = useState("");
  const [newIngImageUri, setNewIngImageUri] = useState("");
  const [editingId, setEditingId] = useState(null); // Speichert die ID, wenn wir gerade editieren
  const [uploading, setUploading] = useState(false);
  //const COMPANY_LOCATION = { lat: 49.53148, lng: 6.03170 }; // Pontpierre
  const COMPANY_LOCATION = { lat: 49.54759, lon: 6.36289 }; //Alibi
  const ALLOWED_DISTANCE = 200; // Erlaubte Entfernung in Metern





  const loadSavedBurger = (savedBurger) => {
    // 1. Wir gehen durch alle IDs des alten Burgers
    const updatedIngredients = savedBurger.stackedIngredients.map(savedIng => {
      // 2. Wir suchen die Zutat in unserer AKTUELLEN ingredients-Liste (die vom Server geladen wurde)
      const currentData = ingredients.find(ing => ing.id === savedIng.id);

      // 3. Wenn gefunden, nehmen wir die frischen Daten (inkl. neuem Preis),
      // ansonsten behalten wir zur Sicherheit die alten (falls eine Zutat gelöscht wurde)
      return currentData ? currentData : savedIng;
    });

    // 4. Den aktuellen Burger-Stapel mit den frischen Daten füllen
    setCurrentBurger(updatedIngredients);

    // 5. Ansicht auf den Baukasten umstellen
    setActiveView('creator');

    console.log(`Burger "${savedBurger.burgerName}" mit aktuellen Preisen geladen.`);
  };
  const getLocation = () => {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error("Geolocation wird nicht unterstützt."));
      } else {
        navigator.geolocation.getCurrentPosition(
          (pos) => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
          (err) => {
            console.error("GPS Fehler Details:", err); // Schau hier in die F12 Konsole!
            reject(err);
          },
          {
            enableHighAccuracy: false, // ÄNDERE DAS ZUM TESTEN AUF FALSE
            timeout: 15000,            // Erhöhe den Timeout auf 15 Sekunden
            maximumAge: 0
          }
        );
      }
    });
  };

  const handleSaveIngredient = async (e) => {
    e.preventDefault();
    const priceNum = parseFloat(newIngPrice);
    if (!newIngName || isNaN(priceNum) || !newIngImageUri) {
      alert("Bitte alle Felder korrekt ausfüllen.");
      return;
    }


    // Die Funktion für den Upload:
    const handleImageUpload = async (e) => {
      const file = e.target.files[0];
      if (!file) return;

      setUploading(true);
      const storageRef = ref(storage, `ingredients/${Date.now()}_${file.name}`);

      try {
        const snapshot = await uploadBytes(storageRef, file);
        const url = await getDownloadURL(snapshot.ref);
        setNewIngImageUri(url); // Speichert die URL für das Formular
        alert("Bild erfolgreich hochgeladen!");
      } catch (error) {
        console.error("Upload Fehler:", error);
        alert("Upload fehlgeschlagen: " + error.message);
      } finally {
        setUploading(false);
      }
    };
    const data = {
      name: newIngName,
      category: newIngCategory,
      price: priceNum,
      imageUri: newIngImageUri
    };

    try {
      if (editingId) {
        // Bestehende Zutat aktualisieren
        await updateDoc(doc(db, "ingredients", editingId), data);
        alert("Zutat aktualisiert!");
      } else {
        // Neue Zutat hinzufügen
        await addDoc(collection(db, "ingredients"), data);
        alert("Zutat hinzugefügt!");
      }
      resetForm();
    } catch (error) {
      alert("Fehler beim Speichern: " + error.message);
    }
  };
  const getDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371e3; // Erdradius in Metern
    const φ1 = (lat1 * Math.PI) / 180;
    const φ2 = (lat2 * Math.PI) / 180;
    const Δφ = ((lat2 - lat1) * Math.PI) / 180;
    const Δλ = ((lon2 - lon1) * Math.PI) / 180;

    const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
      Math.cos(φ1) * Math.cos(φ2) *
      Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c;
  };

  const startEdit = (ing) => {
    setEditingId(ing.id);
    setNewIngName(ing.name);
    setNewIngCategory(ing.category);
    setNewIngPrice(ing.price);
    setNewIngImageUri(ing.imageUri);
    window.scrollTo(0, 0); // Nach oben scrollen zum Formular
  };


  const resetForm = () => {
    setEditingId(null);
    setNewIngName("");
    setNewIngCategory("BUN");
    setNewIngPrice("");
    setNewIngImageUri("");
  };

  // Speichern (Neu oder Update)




  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    // Wir erstellen einen Dateinamen basierend auf der aktuellen Zeit, 
    // damit Namen nicht kollidieren (ähnlich wie in Android)
    const storageRef = ref(storage, `ingredients/${Date.now()}_${file.name}`);

    try {
      // Datei hochladen
      const snapshot = await uploadBytes(storageRef, file);
      // Download-URL generieren
      const url = await getDownloadURL(snapshot.ref);

      // Die generierte URL automatisch in den State für das Formular schreiben
      setNewIngImageUri(url);
      alert("Bild erfolgreich hochgeladen!");
    } catch (error) {
      console.error("Upload Fehler:", error);
      alert("Fehler beim Hochladen: " + error.message);
    } finally {
      setUploading(false);
    }
  };

  const handleEmailLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (error) {
      alert("Login fehlgeschlagen: " + error.message);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      await createUserWithEmailAndPassword(auth, email, password);
      alert("Konto erstellt!");
    } catch (error) {
      alert("Registrierung fehlgeschlagen: " + error.message);
    }
  };
  const isAdmin = user && user.email &&
    user.email.toLowerCase().trim() === ADMIN_EMAIL.toLowerCase().trim();
  console.log("Eingeloggter Nutzer:", user?.email); // <--- DIESE ZEILE HINZUFÜGEN
  console.log("Erwartete Admin-Email:", email);
  console.log("Eingeloggt als:", user?.email, "| Ist Admin?", isAdmin);
  // === DATENLADEN & AUTH ===
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setAuthLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const [activeInvoices, setActiveInvoices] = useState([]);// 2. Effekt zum Laden der Rechnungen (nur wenn Admin)
  const [orders, setOrders] = useState([]); // Bestellungen für Küchen-Monitor
  useEffect(() => {
    // Wir laden die Rechnungen nur, wenn der User Admin ist UND die Kassen-Ansicht aktiv ist
    if (isAdmin && activeView === 'cashier') {
      console.log("Lade offene Rechnungen...");
      const q = query(collection(db, "active_invoices"), orderBy("timestamp", "asc"));

      const unsubscribe = onSnapshot(q, (snapshot) => {
        const invoicesData = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        console.log("Rechnungen empfangen:", invoicesData.length);
        setActiveInvoices(invoicesData);
      }, (error) => {
        console.error("Fehler beim Laden der Kasse:", error);
      });

      return () => unsubscribe();
    }
  }, [isAdmin, activeView]);

  // Lädt die an die Küche gesendeten Bestellungen (collection: "orders")
  useEffect(() => {
    if (isAdmin && activeView === 'kitchen') {
      const q = query(collection(db, "orders"), orderBy("timestamp", "asc"));
      const unsubscribe = onSnapshot(q, (snapshot) => {
        const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setOrders(data);
      }, (err) => console.error("Fehler beim Laden der Küche:", err));

      return () => unsubscribe();
    }
  }, [isAdmin, activeView]);

  // 3. Funktion zum Bezahlen & Archivieren (Cloud Function Aufruf oder Transaktion)
  const handlePayAndArchive = async (invoice) => {
    try {
      // Hier nutzen wir die gleiche Logik wie in der Android-App
      // Wir verschieben von active_invoices nach user_burgers
      const newSavedBurger = {
        burgerName: invoice.burgerName,
        totalPrice: invoice.totalPrice,
        userId: invoice.userId,
        creationTimestamp: serverTimestamp(),
        stackedIngredients: invoice.stackedIngredients
      };

      await addDoc(collection(db, "user_burgers"), newSavedBurger);
      await deleteDoc(doc(db, "active_invoices", invoice.id));
      alert("Rechnung erfolgreich archiviert!");
    } catch (e) {
      alert("Fehler beim Abrechnen: " + e.message);
    }
  };

  // Lädt Zutaten
  useEffect(() => {
    if (user) {
      const ingredientsQuery = query(collection(db, 'ingredients'), orderBy('category'), orderBy('name'));
      const unsubscribe = onSnapshot(ingredientsQuery, (snapshot) => {
        const ingredientsData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data(), zOrder: zOrderMap[doc.data().category.trim()] || 99 }));
        setIngredients(ingredientsData);
        setLoading(false);
      });
      return () => unsubscribe();
    }
  }, [user]);

  // Lädt gespeicherte Burger
  useEffect(() => {
    if (!user) return;

    const q = query(collection(db, "user_burgers"),
      where("userId", "==", user.uid)
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const burgersWithIds = snapshot.docs.map(doc => {
        const data = doc.data();
        return {
          ...data,
          id: doc.id // <--- DAS IST DER ENTSCHEIDENDE TEIL!
        };
      });

      console.log("Burger geladen:", burgersWithIds); // Kontrollblick in die Konsole
      setSavedBurgers(burgersWithIds);
    });

    return () => unsubscribe();
  }, [user]);

  // === FUNKTIONEN ===
  const handleGoogleLogin = () => {
    const provider = new GoogleAuthProvider();
    signInWithPopup(auth, provider).catch(error => console.error("Google Login Fehler:", error));
  };
  const handleLogout = () => { signOut(auth).catch(error => console.error("Logout Fehler:", error)); };
  const handleAddIngredient = (ingredient) => {
    // 1. Kategorien definieren, die sich GEGENSEITIG ausschließen (nur EINE pro Kategorie)
    const exclusiveCategories = {
      'BEILAGE': ['BEILAGE'],
      'B_SALAT': ['B_SALAT']
    };

    // 2. Sauce-Kategorien können BEIDE existieren (nicht gegenseitig ausschließend)
    // ABER: maximal 2 Soßen insgesamt!
    const sauceSideCategories = ['B_SAUCE', 'B_SAUCE_2'];
    
    // 3. Alle Beilagen-Kategorien
    const allSideCategories = ['BEILAGE', 'B_SAUCE', 'B_SAUCE_2', 'B_SALAT'];

    if (exclusiveCategories[ingredient.category]) {
      // Falls es BEILAGE oder B_SALAT ist: nur eine pro Kategorie
      setCurrentBurger(prev => [
        ...prev.filter(item => item.category !== ingredient.category),
        ingredient
      ]);
    } else if (sauceSideCategories.includes(ingredient.category)) {
      // Falls es Soße ist: maximal 2 Soßen insgesamt
      const existingSauces = currentBurger.filter(item => sauceSideCategories.includes(item.category));
      
      // Falls bereits 2 Soßen vorhanden sind und diese ist neu, nicht hinzufügen
      if (existingSauces.length >= 2 && !currentBurger.some(item => item.id === ingredient.id)) {
        alert("Du kannst maximal 2 Beilagen-Soßen wählen!");
        return;
      }
      
      // Ansonsten hinzufügen/ersetzen
      setCurrentBurger(prev => [
        ...prev.filter(item => item.id !== ingredient.id), // Nur DIESES Item raus, nicht die ganze Kategorie
        ingredient
      ]);
    } else if (allSideCategories.includes(ingredient.category)) {
      // Sonstige Beilagen
      setCurrentBurger(prev => [
        ...prev.filter(item => item.category !== ingredient.category),
        ingredient
      ]);
    } else if (ingredient.category === 'BUN') {
      // Spezialbehandlung für Brötchen: Entferne alte BUN_BOTTOM/BUN_TOP und füge neue hinzu
      const bunCategories = ['BUN_BOTTOM', 'BUN_TOP'];
      
      // Suche nach den tatsächlichen BUN_BOTTOM und BUN_TOP Zutaten
      const bunBottom = ingredients.find(ing => ing.category === 'BUN_BOTTOM');
      const bunTop = ingredients.find(ing => ing.category === 'BUN_TOP');
      
      setCurrentBurger(prev => {
        // Filtere alte Brötchen raus
        const newBurger = prev.filter(item => !bunCategories.includes(item.category));
        
        // Füge die neuen Brötchen hinzu
        if (bunBottom) newBurger.push(bunBottom);
        if (bunTop) newBurger.push(bunTop);
        
        return newBurger;
      });
    } else {
      // 4. Für normale Zutaten (Fleisch, Käse etc.) einfach hinzufügen
      setCurrentBurger(prev => [...prev, ingredient]);
    }
  };
  //const handleRemoveIngredient = () => { setCurrentBurger(prevBurger => prevBurger.slice(0, -1)); };
  const handleRemoveIngredient = (ingredientToRemove) => {
    // Definition der Beilagen-Kategorien (falls noch nicht global geschehen)
    const sideCategories = ['BEILAGE', 'B_SAUCE', 'B_SAUCE_2', 'B_SALAT'];

    if (ingredientToRemove && ingredientToRemove.id) {
      // FALL 1: Wir haben ein gezieltes Objekt (z.B. Klick auf "löschen" unter der Beilage)
      // Wir filtern genau dieses Objekt aus der Liste heraus
      setCurrentBurger(prev => prev.filter(item => item !== ingredientToRemove));
    } else {
      // FALL 2: Der allgemeine "Entfernen"-Button für den Stapel wurde geklickt
      // Wir löschen das letzte Element, das KEINE Beilage ist
      setCurrentBurger(prev => {
        const lastMainPartIndex = [...prev].reverse().findIndex(ing => !sideCategories.includes(ing.category));

        if (lastMainPartIndex === -1) return prev; // Nichts zu löschen

        const actualIndex = prev.length - 1 - lastMainPartIndex;
        return prev.filter((_, i) => i !== actualIndex);
      });
    }
  };

  // ====================================================================
  //  HIER IST DER ENTSCHEIDENDE TEIL: handlePlaceOrder
  // ====================================================================
  const handlePlaceOrder = async () => {
  if (currentBurger.length === 0 || !user) {
    alert("Bitte erstelle einen Burger und melde dich an!");
    return;
  }

  // Lade-Indikator starten (optional, falls du einen hast)
  console.log("Starte Standortabfrage...");

  try {
    const position = await new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject, {
        enableHighAccuracy: true,
        timeout: 10000, // 10 Sekunden Zeit geben
        maximumAge: 0    // Keine veralteten Cache-Daten nutzen
      });
    });

    const userLat = position.coords.latitude;
    const userLon = position.coords.longitude;

    const distance = getDistance(
      userLat, userLon,
      COMPANY_LOCATION.lat, COMPANY_LOCATION.lon
    );

    console.log(`Distanz berechnet: ${distance}m`);

    if (distance > ALLOWED_DISTANCE) {
      alert(`Bestellung leider nicht möglich. Du bist zu weit entfernt (${Math.round(distance)}m). 
      Bitte zum Restaurant kommen.`);
      return;
    }

    const burgerName = prompt("Gib deinem Burger einen Namen für die Küche:");
    if (!burgerName) return;

    // ... (Zutaten sortieren wie zuvor)
    const sortedIngredients = [...currentBurger]
      .sort((a, b) => (a.zOrder || 0) - (b.zOrder || 0))
      .map(ing => ({
        id: ing.id,
        name: ing.name,
        imageUri: ing.imageUri,
        category: ing.category,
        zOrder: ing.zOrder
      }));

    const orderData = {
      burgerName: burgerName,
      totalPrice: totalPrice,
      userId: user.uid,
      userName: user.displayName || user.email || 'Gast',
      timestamp: serverTimestamp(),
      stackedIngredients: sortedIngredients
    };

    await addDoc(collection(db, "orders"), orderData);
    alert(`Erfolg! "${burgerName}" wurde an die Küche gesendet.`);
    setCurrentBurger([]);

  } catch (error) {
    console.error("Geolocation Fehler Details:", error);
    
    if (error.code === 1) {
      alert("Standortzugriff wurde abgelehnt. Bitte aktiviere ihn in den Browsereinstellungen für diese Seite.");
    } else if (error.code === 3) {
      alert("Zeitüberschreitung! Dein Standort konnte nicht schnell genug gefunden werden. Versuche es im Freien oder mit besserem Empfang.");
    } else {
      alert("Standort-Fehler: " + error.message);
    }
  }
};

  const handleDeleteSavedBurger = async (burgerId) => {
    // Hier kam deine Fehlermeldung her, weil burgerId leer war
    if (!burgerId) {
      console.error("Keine Burger-ID zum Löschen gefunden!");
      return;
    }

    try {
      // Pfad: Sammlung "user_burgers", Dokument "burgerId"
      await deleteDoc(doc(db, "user_burgers", burgerId));
      alert("Burger wurde gelöscht!");
    } catch (error) {
      console.error("Fehler beim Löschen:", error);
    }
  };
  const updatePrice = async (id, newPrice) => {
    const p = parseFloat(newPrice);
    if (isNaN(p)) {
      alert("Bitte gib einen gültigen Preis ein.");
      return;
    }
    try {
      const ingredientRef = doc(db, "ingredients", id);
      await updateDoc(ingredientRef, { price: p });
      console.log("Preis erfolgreich aktualisiert!");
    } catch (error) {
      console.error("Fehler beim Aktualisieren des Preises:", error);
      alert("Fehler beim Speichern: " + error.message);
    }
  };

  const deleteIngredient = async (id) => {
    if (!window.confirm("Möchtest du diese Zutat wirklich endgültig löschen?")) {
      return;
    }
    try {
      await deleteDoc(doc(db, "ingredients", id));
      alert("Zutat gelöscht.");
    } catch (error) {
      console.error("Fehler beim Löschen:", error);
      alert("Fehler beim Löschen: " + error.message);
    }
  };
  const totalPrice = useMemo(() => currentBurger.reduce((sum, ing) => sum + ing.price, 0), [currentBurger]);
  // 1. Burger-Teile (Fleisch, Käse, Brötchen unten/oben, etc.) - OHNE Beilagen!
  const burgerMainParts = currentBurger.filter(ing =>
    !['BEILAGE', 'B_SAUCE', 'B_SAUCE_2', 'B_SALAT'].includes(ing.category)
  ).sort((a, b) => a.zOrder - b.zOrder);

  // 2. Nur die Beilagen für die Reihe darunter
  const sideDishes = currentBurger.filter(ing =>
    ['BEILAGE', 'B_SAUCE', 'B_SAUCE_2', 'B_SALAT'].includes(ing.category)
  );


  if (authLoading) { return <div className="App"><h1>Lade...</h1></div>; }
  if (!user) {
    return (
      <div className="App">
        <header className="App-header">
          <h3>Burger Architect</h3>
        </header>
        <main className="login-screen">
          <div className="login-box">
            <h2>Willkommen zurück! 🍔</h2>
            <p>Melde dich an, um deinen nächsten Meister-Burger zu entwerfen.</p>

            {/* E-MAIL FORMULAR */}
            <form onSubmit={isRegistering ? handleRegister : handleEmailLogin} className="login-form">
              <input
                type="email"
                placeholder="E-Mail Adresse"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <input
                type="password"
                placeholder="Passwort"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button type="submit" className="login-button">
                {isRegistering ? "Jetzt Registrieren" : "Einloggen"}
              </button>
            </form>

            <div className="auth-divider">
              <span>oder</span>
            </div>

            {/* GOOGLE LOGIN */}
            <button onClick={handleGoogleLogin} className="google-login-btn">
              {/* Hier kannst du ein Google-Icon-Bild einfügen oder ein Emoji nutzen */}
              <span className="google-icon">🌐</span>
              Mit Google anmelden
            </button>

            {/* WECHSEL ZWISCHEN LOGIN/REGISTRIERUNG */}
            <p className="auth-toggle-text">
              {isRegistering ? "Du hast schon ein Konto?" : "Noch kein Konto?"}
              <span onClick={() => setIsRegistering(!isRegistering)}>
                {isRegistering ? " Hier zum Login" : " Hier registrieren"}
              </span>
            </p>
            <div className="footer-text">
              Burger Architekt v3.0
            </div>
          </div>
        </main>
      </div>
    );
  }


  // --- In deiner App.js (Web-App) ---

  return (
    <div className="App">
      <header className="App-header">
        <div className="header-top-row">    <h1 className="main-logo">Burger Architekt</h1>
          <div className="user-controls">
            <span className="welcome-text">Hallo, {user.displayName || user.email}!</span>

            <button onClick={handleLogout} className="logout-mini-btn" title="Abmelden">🚪</button>
          </div>
        </div>

        <nav className="main-nav">
          {/* Diese Buttons sehen alle User */}
          <button onClick={() => setActiveView('creator')}>🏠 <span className="hide-mobile">Baukasten</span></button>
          <button onClick={() => setActiveView('saved')}>📂 <span className="hide-mobile">Kreationen</span></button>

          {/* NUR wenn isAdmin true ist, werden Kasse UND Admin angezeigt */}
          {isAdmin && (
            <>
              <button onClick={() => setActiveView('cashier')} disabled={activeView === 'invoices'}>
                💰 <span className="hide-mobile">Kasse</span>
              </button>

              <button onClick={() => setActiveView('kitchen')} disabled={activeView === 'kitchen'}>
                🍽️ <span className="hide-mobile">Küche</span>
              </button>

              <button onClick={() => setActiveView('admin')} disabled={activeView === 'admin'}>
                ⚙️ <span className="hide-mobile">Admin</span>
              </button>
            </>
          )}
        </nav>
      </header>

      {/* 3. HAUPTBEREICH */}
      <main>
        {/* 1. ANSICHT: BURGER-BAUKASTEN */}


        {activeView === 'creator' && (
          <div className="main-container">
            <div className="burger-builder card-look">
              <h2>Dein Burger</h2>

              {/* 1. Stapel-Visualisierung */}
              <div className="burger-visual-container">
                {/* Prüfen, ob der Burger leer ist (Hauptteile UND Beilagen) */}
                {burgerMainParts.length === 0 && sideDishes.length === 0 ? (
                  <div className="burger-placeholder">
                    <div className="placeholder-icon">🍔</div>
                    <p>Baue deinen Burger!</p>
                  </div>
                ) : (
                  <>
                    {/* Dein bisheriger Code für den Stapel und die Namen: */}
                    <div className="stack-visual-box">
                      {burgerMainParts.map((ingredient, index) => (
                        <img
                          key={`img-${index}`}
                          src={ingredient.imageUri}
                          alt=""
                          className="visual-stack-img"
                          style={{ zIndex: ingredient.zOrder }}
                        />
                      ))}
                    </div>

                    <div className="stack-names-list">
                      {burgerMainParts.map((ingredient, index) => (
                        <div key={`name-${index}`} className="stack-name-item">
                          <span>• {ingredient.name}</span>
                          <span className="delete-x" onClick={() => handleRemoveIngredient(ingredient)}>✕</span>
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </div>

              {/* 2. Beilagen-Reihe */}
              <div className="sides-display-row" style={{
                display: 'flex',
                justifyContent: 'space-around',
                padding: '10px',
                backgroundColor: '#f0f0f0',
                borderRadius: '8px',
                marginTop: '10px'
              }}>
                {/* Beilage */}
                {(() => {
                  const item = sideDishes.find(s => s.category === 'BEILAGE');
                  return (
                    <div style={{ textAlign: 'center', width: '22%' }}>
                      {item ? (
                        <div onClick={() => handleRemoveIngredient(item)} style={{ cursor: 'pointer' }}>
                          <img src={item.imageUri} alt={item.name} style={{ height: '50px', borderRadius: '4px' }} />
                          <p style={{ fontSize: '10px', margin: '0' }}>{item.name}</p>
                          <span style={{ fontSize: '9px', color: 'red' }}>löschen</span>
                        </div>
                      ) : (
                        <div style={{ height: '50px', border: '1px dashed #ccc', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#ccc', fontSize: '20px' }}>+</div>
                      )}
                    </div>
                  );
                })()}

                {/* Soßen (B_SAUCE + B_SAUCE_2) */}
                {(() => {
                  const sauces = sideDishes.filter(s => ['B_SAUCE', 'B_SAUCE_2'].includes(s.category));
                  return (
                    <div style={{ textAlign: 'center', width: '22%' }}>
                      {sauces.length > 0 ? (
                        <div>
                          {sauces.map((sauce, idx) => (
                            <div key={idx} onClick={() => handleRemoveIngredient(sauce)} style={{ cursor: 'pointer', marginBottom: idx < sauces.length - 1 ? '5px' : '0' }}>
                              <img src={sauce.imageUri} alt={sauce.name} style={{ height: '35px', borderRadius: '4px' }} />
                              <p style={{ fontSize: '9px', margin: '2px 0' }}>{sauce.name}</p>
                            </div>
                          ))}
                          <span style={{ fontSize: '9px', color: 'red' }}>löschen</span>
                        </div>
                      ) : (
                        <div style={{ height: '50px', border: '1px dashed #ccc', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#ccc', fontSize: '20px' }}>+</div>
                      )}
                    </div>
                  );
                })()}

                {/* Salat */}
                {(() => {
                  const item = sideDishes.find(s => s.category === 'B_SALAT');
                  return (
                    <div style={{ textAlign: 'center', width: '22%' }}>
                      {item ? (
                        <div onClick={() => handleRemoveIngredient(item)} style={{ cursor: 'pointer' }}>
                          <img src={item.imageUri} alt={item.name} style={{ height: '50px', borderRadius: '4px' }} />
                          <p style={{ fontSize: '10px', margin: '0' }}>{item.name}</p>
                          <span style={{ fontSize: '9px', color: 'red' }}>löschen</span>
                        </div>
                      ) : (
                        <div style={{ height: '50px', border: '1px dashed #ccc', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#ccc', fontSize: '20px' }}>+</div>
                      )}
                    </div>
                  );
                })()}
              </div>

              {/* 3. Buttons */}
              <div className="burger-controls">
                {/* Button: Leeren */}
                <button
                  onClick={() => setCurrentBurger([])}
                  className="clear-button"
                  disabled={currentBurger.length === 0}
                >
                  <span>🗑️</span> Leeren
                </button>

                {/* Button: Bestellen */}
                <button
                  onClick={handlePlaceOrder}
                  className="order-button"
                  disabled={currentBurger.length === 0}
                >
                  <span>✅</span> Bestellen
                </button>
              </div>
            </div> {/* Schließt burger-builder */}

            {/* 4. Zutaten-Auswahl */}
            <div className="ingredient-selector">  <h2>Wähle deine Zutaten</h2>
              {loading && <p>Lade Zutaten...</p>}

              {/* Wir definieren die Reihenfolge der Kategorien - BUN_BOTTOM und BUN_TOP NICHT anzeigen! */}
              {['BUN', 'MEAT', 'CHEESE', 'VEGETABLE', 'SAUCE', 'BEILAGE', 'B_SAUCE', 'B_SAUCE_2', 'B_SALAT'].map(cat => {
                // Filtert die Zutaten für die aktuelle Kategorie
                const catIngredients = ingredients.filter(ing => ing.category === cat);
                if (catIngredients.length === 0) return null;

                return (
                  <div key={cat} className="category-section">
                    <h3 className="category-title">
                      {/* Mapping der technischen Namen auf schöne Titel */}
                      {cat === 'BUN' ? 'Brötchen' :
                        cat === 'MEAT' ? 'Fleisch' :
                          cat === 'VEGETABLE' ? 'Gemüse' :
                            cat === 'B_SAUCE' ? 'Beilagen Soße' :
                              cat === 'B_SAUCE_2' ? 'Beilagen Soße 2' :
                                cat === 'SAUCE' ? 'Soße' :
                                  cat === 'B_SALAT' ? 'Beilagen Salat' :
                                    cat === 'BEILAGE' ? 'Beilagen' : cat.charAt(0) + cat.slice(1).toLowerCase()}
                    </h3>

                    <div className="category-scroll-row">
                      {catIngredients.map(ingredient => {
                        // Prüfe, ob diese Zutat bereits im Burger ist
                        const isSelected = currentBurger.some(item => item.id === ingredient.id);
                        
                        return (
                          <div 
                            key={ingredient.id} 
                            className={`ingredient-card ${isSelected ? 'selected' : ''}`} 
                            onClick={() => handleAddIngredient(ingredient)}
                          >
                            <img src={ingredient.imageUri} alt={ingredient.name} />
                            <p>{ingredient.name}</p>
                            <span>{ingredient.price.toFixed(2)} €</span>
                            {isSelected && <div className="selected-checkmark">✓</div>}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          </div> // Schließt main-container
        )}

        {/* 2. ANSICHT: MEINE KREATIONEN */}
        {activeView === 'saved' && (
          <div className="saved-view-container">
            <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Meine Burger-Kreationen</h2>

            <div className="saved-burgers-grid">
              {savedBurgers.map((burger) => {
                // --- LOGIK: Burger und Beilagen für diese Karte trennen ---
                const mainParts = burger.stackedIngredients
                  .filter(ing => !['BEILAGE', 'B_SAUCE', 'B_SAUCE_2', 'B_SALAT'].includes(ing.category))
                  .sort((a, b) => (a.zOrder || 0) - (b.zOrder || 0));

                const sides = burger.stackedIngredients
                  .filter(ing => ['BEILAGE', 'B_SAUCE', 'B_SAUCE_2', 'B_SALAT'].includes(ing.category));

                return (
                  <div key={burger.id} className="burger-card">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                      <h3 style={{ margin: 0 }}>{burger.burgerName}</h3>
                      <button onClick={() => handleDeleteSavedBurger(burger.id)} className="delete-icon-btn">🗑️</button>
                    </div>

                    <p className="card-date">
                      {burger.creationTimestamp ? new Date(burger.creationTimestamp.toDate()).toLocaleDateString() : 'Datum unbekannt'}
                    </p>


                    {/* VISUELLER BEREICH (Bilder) */}
                    <div className="card-visual-section" style={{
                      display: 'flex',
                      color: '#010101',
                      gap: '15px',
                      alignItems: 'flex-end',
                      marginTop: '10px',    // Verringert von 15px
                      marginBottom: '5px'   // Stark verringert (Abstand zu den Namen)
                    }}>
                      {/* Linke Seite: Der Burger-Stapel */}
                      <div className="saved-burger-stack " style={{ flex: 1, height: '100px' }}> {/* Höhe etwas reduziert */}
                        {mainParts.map((ing, idx) => (
                          <img key={idx} src={ing.imageUri} alt="" className="card-ingredient-img" style={{ zIndex: ing.zOrder }} />


                        ))}
                      </div>

                      {/* Rechte Seite: Die Beilagen */}
                      <div className="card-sides-preview" style={{ display: 'flex', flexDirection: 'row', gap: '1px' }}>
                        {sides.map((side, idx) => (
                          <img key={idx} src={side.imageUri} alt="" style={{ height: '30px', borderRadius: '4px' }} title={side.name} />
                        ))}
                      </div>
                    </div>

                    {/* ZUTATEN-NAMEN (Jetzt mit minimalem Abstand) */}
                    <div className="card-ingredients-list" style={{

                      fontSize: '0.8rem',   // Etwas kleinere Schrift spart Platz
                      color: '#010101',
                      marginBottom: '5px',  // Stark verringert (Abstand zum Preis)
                      textAlign: 'left',
                      paddingLeft: '40px'
                    }}>
                      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>

                        {[...burger.stackedIngredients]
                          .sort((a, b) => (b.zOrder || 0) - (a.zOrder || 0)) // b - a für Absteigend (Deckel zuerst)
                          .toReversed().map((ing, idx) => (
                            <li key={idx} style={{ lineHeight: '1.2' }}>• {ing.name}</li>
                          ))
                        }
                      </ul>

                    </div>

                    <div style={{ marginTop: 'auto' }}>
                      <p className="card-price">{(burger.totalPrice || 0).toFixed(2)} €</p>
                      <button onClick={() => loadSavedBurger(burger)} className="load-btn">Neu bestellen</button>
                    </div>
                  </div>

                );
              })}
            </div>
          </div>
        )}

        {/* 3. ANSICHT: ADMIN-BEREICH */}
        {activeView === 'admin' && isAdmin && (
          <main className="admin-view">
            <h2>Bestandsverwaltung ⚙️</h2>
            {/* NEU: FORMULAR ZUM HINZUFÜGEN / EDITIEREN */}
            <section className="admin-form-section">
              <h3>{editingId ? "Zutat bearbeiten" : "Neue Zutat hinzufügen"}</h3>
              <form onSubmit={handleSaveIngredient} className="admin-form">
                <input
                  type="text" placeholder="Name (z.B. Rindfleisch)"
                  value={newIngName} onChange={(e) => setNewIngName(e.target.value)}
                />
                <select value={newIngCategory} onChange={(e) => setNewIngCategory(e.target.value)}>
                  <option value="BUN">Brötchen</option>
                  <option value="MEAT">Fleisch / Patty</option>
                  <option value="CHEESE">Käse</option>
                  <option value="VEGETABLE">Gemüse</option>
                  <option value="SAUCE">Soße</option>
                  <option value="SECRET">Secret</option>
                  <option value="FISH">Fish</option>
                  <option value="BEILAGE">Beilage</option>
                  <option value="B_SALAT">Beilage-Salat</option>
                  <option value="B_SAUCE">Beilage-Soße</option>
                  <option value="B_SAUCE_2">Beilage-Soße 2</option>
                </select>
                <input
                  type="number" step="0.1" placeholder="Preis in €"
                  value={newIngPrice} onChange={(e) => setNewIngPrice(e.target.value)}
                />
                {/* Ersatz für das Textfeld: Der Upload-Bereich */}
                <div className="upload-section">
                  <label className="file-input-label">
                    {uploading ? "Wird hochgeladen..." : "Bild auswählen & hochladen"}
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleImageUpload}
                      disabled={uploading}
                      style={{ display: 'none' }}
                    />
                  </label>

                  {/* Kleine Vorschau, damit du siehst, ob es geklappt hat */}
                  {newIngImageUri && (
                    <img src={newIngImageUri} alt="Vorschau" style={{ height: '40px', borderRadius: '4px', border: '1px solid #ccc' }} />
                  )}
                </div>

                <div className="form-buttons">
                  <button type="submit" className="save-btn">
                    {editingId ? "Änderungen speichern" : "Hinzufügen"}
                  </button>
                  {editingId && <button type="button" onClick={resetForm} className="cancel-btn">Abbrechen</button>}
                </div>
              </form>
            </section>

            <div className="table-container">
              <table className="admin-table">
                <thead>
                  <tr>
                    <th>Bild</th>
                    <th>Name</th>
                    <th>Preis</th>
                    <th>Aktionen</th>
                  </tr>
                </thead>
                <tbody>
                  {ingredients.map((ing) => (
                    <tr key={ing.id}>
                      <td><img src={ing.imageUri} alt="" style={{ height: '30px' }} /></td>
                      <td>{ing.name} ({ing.category})</td>
                      <td>{ing.price.toFixed(2)} €</td>
                      <td>
                        <button className="icon-btn edit" onClick={() => startEdit(ing)}>✏️</button>
                        <button className="icon-btn delete" onClick={() => deleteIngredient(ing.id)}>🗑️</button>

                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </main> // Schließt <main className="admin-view">
        )}
        {activeView === 'cashier' && isAdmin && (
          <div className="cashier-view" style={{ padding: '20px' }}>
            <h2 style={{ textAlign: 'center' }}>Kassen-Monitor</h2>

            {activeInvoices.length === 0 ? (
              <div style={{ textAlign: 'center', marginTop: '50px', color: '#888' }}>
                <p>Aktuell keine offenen Rechnungen.</p>
                <button onClick={() => setActiveView('creator')} style={{ marginTop: '10px' }}>Zurück zum Baukasten</button>
              </div>
            ) : (
              <div className="invoices-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '20px', marginTop: '20px' }}>
                {activeInvoices.map((invoice) => (
                  <div key={invoice.id} className="invoice-card" style={{ border: '1px solid #ddd', padding: '15px', borderRadius: '8px', background: '#fff', boxShadow: '0 2px 5px rgba(0,0,0,0.1)' }}>
                    <h3>{invoice.burgerName}</h3>
                    <p><strong>Kunde:</strong> {invoice.userName || 'Unbekannt'}</p>
                    <p><strong>Preis:</strong> {invoice.totalPrice?.toFixed(2)} €</p>
                    <hr />
                    {invoice.stackedIngredients && invoice.stackedIngredients.length > 0 && (
                      <div style={{ marginBottom: '10px' }}>
                        <strong>Zutaten:</strong>
                        <ul style={{ margin: '6px 0 0 14px', padding: 0 }}>
                          {invoice.stackedIngredients.map((ing, idx) => (
                            <li key={idx} style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '0.9rem' }}>
                              <img src={ing.imageUri} alt={ing.name} style={{ height: '28px', width: '28px', objectFit: 'cover', borderRadius: '4px' }} />
                              <span style={{ lineHeight: 1 }}>{ing.name}{ing.price ? ` - ${ing.price.toFixed(2)} €` : ''}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                    <button
                      onClick={() => handlePayAndArchive(invoice)}
                      style={{ width: '100%', padding: '10px', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}
                    >
                      Bezahlt & Archivieren
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {activeView === 'kitchen' && isAdmin && (
          <div className="kitchen-view" style={{ padding: '20px' }}>
            <h2 style={{ textAlign: 'center' }}>Küchen-Monitor</h2>

            {orders.length === 0 ? (
              <div style={{ textAlign: 'center', marginTop: '50px', color: '#888' }}>
                <p>Aktuell keine Bestellungen in der Küche.</p>
                <button onClick={() => setActiveView('creator')} style={{ marginTop: '10px' }}>Zurück zum Baukasten</button>
              </div>
            ) : (
              <div className="orders-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: '20px', marginTop: '20px' }}>
                {orders.map((order) => (
                  <div key={order.id} className="order-card" style={{ border: '1px solid #ddd', padding: '15px', borderRadius: '8px', background: '#fff' }}>
                    <h3 style={{ marginTop: 0 }}>{order.burgerName}</h3>
                    <p style={{ margin: '6px 0' }}><strong>Kunde:</strong> {order.userName || 'Unbekannt'}</p>
                    <p style={{ margin: '6px 0' }}><strong>Bestellt:</strong> {order.timestamp ? new Date(order.timestamp.toDate()).toLocaleTimeString() : '–'}</p>

                    {order.stackedIngredients && order.stackedIngredients.length > 0 && (
                      <div style={{ marginTop: '8px' }}>
                        <strong>Zutaten:</strong>
                        <ul style={{ margin: '6px 0 0 14px', padding: 0 }}>
                          {order.stackedIngredients.map((ing, idx) => (
                            <li key={idx} style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '0.9rem' }}>
                              <img src={ing.imageUri} alt={ing.name} style={{ height: '28px', width: '28px', objectFit: 'cover', borderRadius: '4px' }} />
                              <span style={{ lineHeight: 1 }}>{ing.name}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}

                    <div style={{ marginTop: '12px' }}>
                      <button
                        onClick={async () => {
                          if (!window.confirm('Markiere diesen Auftrag als fertig?')) return;
                          try {
                            await deleteDoc(doc(db, 'orders', order.id));
                            alert('Auftrag als erledigt markiert.');
                          } catch (e) {
                            console.error('Fehler beim Löschen der Bestellung:', e);
                            alert('Fehler: ' + e.message);
                          }
                        }}
                        style={{ width: '100%', padding: '10px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                      >
                        Fertig
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}


      </main>
    </div >
  );

}

export default App;
